class Coupon {
    id;
    code;
    description;
    status;
    numberOfBricks;
    retailPrice;
    pricePerBrick;
    discount;
    totalAmount;
    totalRetailPrice;
    expiresAt;
    crowdfundingPropertyId;
    constructor(data) {
        this.id = data.id;
        this.code = data.code;
        this.description = data.description;
        this.status = data.status;
        this.numberOfBricks = data.numberOfBricks;
        this.retailPrice = data.retailPrice;
        this.pricePerBrick = data.pricePerBrick;
        this.discount = data.discount;
        this.totalAmount = data.totalAmount;
        this.totalRetailPrice = data.totalRetailPrice;
        this.expiresAt = data.expiresAt;
        this.crowdfundingPropertyId = data.crowdfundingPropertyId;
    }
}
export default Coupon;
